import React, { Component } from 'react';

import Modal from 'components/cosmos/modal';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class UpdateDataModal extends Component {
  static propTypes = {
    confirmModal: PropTypes.func,
    closeModal: PropTypes.func,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string
  };

  header = () => {
    const { title } = this.props;

    return (
      <h3 className="_font-weight-bold">
        <I18n label={title} />
      </h3>
    );
  };

  footer = () => {
    const { confirmModal, closeModal } = this.props;

    return (
      <>
        <button
          className="hot-button hot-button--primary hot-button--lg _mr-4"
          onClick={confirmModal}
        >
          <I18n label="general.ok" />
        </button>
        <button
          className="hot-button hot-button--secondary hot-button--lg"
          onClick={closeModal}
        >
          <I18n label="general.cancel" />
        </button>
      </>
    );
  };

  render() {
    const { closeModal, isOpen, description } = this.props;

    return (
      <Modal
        header={this.header()}
        footer={this.footer()}
        open={isOpen}
        onClose={closeModal}
      >
        <I18n label={description} />
      </Modal>
    );
  }
}
